export const DATE_FORMATS = {
  BACKEND: 'yyyy-MM-dd',
  DISPLAY: 'dd MMMM yyyy'
};

export const ERROR_MESSAGES = {
  NO_DATE_SELECTED: 'Будь ласка, оберіть дату',
  NO_ROUTES_FOUND: 'Рейси не знайдено для обраної дати',
  NO_BUS_MAP_DATE: 'Дата не обрана для запиту карти автобуса.',
  NO_SERVER_DATA: 'Дані не отримано від сервера',
  FETCH_ROUTES_ERROR: 'Помилка отримання списку рейсів',
  FETCH_BUS_MAP_ERROR: 'Помилка отримання карти автобуса'
};

export const UI_CONSTANTS = {
  CALENDAR_Z_INDEX: 1000,
  WITHPASS_VALUE: 1
};

export const KEYBOARD_KEYS = {
  ESCAPE: 'Escape',
  ENTER: 'Enter',
  SPACE: ' '
};